import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import appsSaga from './apps/data/sagas';
import pageReducer from './data/reducer';
import routes from './data/routes';
import pageSaga from './data/sagas';
import geometricInterrogationReducer from './geometricInterrogation/data/reducer';
import geometricInterrogationSaga from './geometricInterrogation/data/sagas';
import pennAppReducer from './penn/fastenerAvailability/data/reducer';
import pennAppSaga from './penn/fastenerAvailability/data/sagas';

const reducer = combineReducers({
  app: combineReducers({
    geometricInterrogation: geometricInterrogationReducer,
    page: pageReducer,
    pennApp: pennAppReducer,
  }),
});

const saga = function* () {
  yield all([
    appsSaga(),
    geometricInterrogationSaga(),
    pageSaga(),
    pennAppSaga(),
  ]);
};

export { reducer, routes, saga };
